import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  open: boolean;
  title: string;
  message?: ReactNode;
  buttonLabel?: string;
  onClose: () => void;
}

export function AlertDialog({
  open,
  title,
  message,
  buttonLabel = 'OK',
  onClose,
}: Props) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-6">
      <button
        type="button"
        aria-label="Close"
        className="bt-flat absolute inset-0"
        style={{
          background: 'rgba(15,23,42,0.5)',
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
        }}
        onClick={onClose}
      />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="alert-dialog-title"
        className="relative z-10 w-full max-w-[320px] rounded-2xl border border-line bg-paper p-5 shadow-bt"
      >
        <h2 id="alert-dialog-title" className="font-serif text-lg font-bold tracking-tight text-ink">
          {title}
        </h2>
        {message && (
          <p className="mt-2 text-sm leading-relaxed text-ink-soft">{message}</p>
        )}
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full rounded-full bg-navy py-2.5 text-sm font-bold text-cream"
        >
          {buttonLabel}
        </button>
      </div>
    </div>,
    document.body,
  );
}
